import React, { Component } from 'react';
import axios from 'axios';
import { Loader, Segment, Header, Icon, Popup, Message } from 'semantic-ui-react';

import {
    fetchAcademicYears,
    fetchAllAcademicYears,
    fetchCountries,
    fetchFaculties
} from '../../Lookups/util';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';
import { IconHeader } from '../../Assets/util/css';
import ExternalStudentsTable from '../ExternalStudentTable';
import { filterStudents } from '../ExternalStudentList';
import { Link } from 'react-router-dom';

class RegistrationLinkStudentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            students: [],
            filteredStudents: [],
            loading: true,
            studentOrganizationalUnits: [],
            academicYears: [],
            faculties: [],
            countries: [],

            selectedAcademicYearId: null,
            selectedFacultyId: null,
            selectedCountryId: null,
            searchText: '',
            activePage: 1,
            postsPerPage: 10,

            excelData: [],

            deletingRowId: null,
            saving: false,

            registrationLink: null,
        };

        this.fetchInitialData = this.fetchInitialData.bind(this);
        this.getResults = this.getResults.bind(this);
        this.handleSearchTextChange = this.handleSearchTextChange.bind(this);
        this.filterStudents = this.filterStudents.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);

    }

    componentDidMount() {
        const location = this.props.location;
        let registrationLink = null;

        if (location && location.state && location.state.link) {
            registrationLink = location.state.link;
            localStorage.setItem('registrationLink', JSON.stringify(registrationLink));
        } else {
            registrationLink = JSON.parse(localStorage.getItem('registrationLink'));
        }

        this.setState({ registrationLink }, () => this.fetchInitialData());
    }

    fetchInitialData() {
        this.setState({ loading: true });

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isInternationalCooperationService = localStorageRole === 'Služba za međunarodnu saradnju';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';


        const requests = [
            axios.get(`/external-student/by-registration-link/${this.state.registrationLink.id}`),
            fetchFaculties(),
            fetchAcademicYears(),
            fetchCountries(),
        ];

        if (isAdmin || isInternationalCooperationService) {
            requests.push(axios.get('/external-student-organization-unit'));
        }

        Promise.all(requests)
            .then((responses) => {
                const externalStudentsResponse = responses[0];
                const facultiesResponse = responses[1];
                const academicYearsResponse = responses[2];
                const countriesResponse = responses[3];
                let studentOrganizationalUnitsResponse = { data: [] };
                if (isAdmin || isInternationalCooperationService) {
                    studentOrganizationalUnitsResponse = responses[4];
                }

                const sortedStudents = externalStudentsResponse.data.sort((a, b) => {
                    const dateA = new Date(a.dateTo);
                    const dateB = new Date(b.dateTo);
                    return dateB - dateA; // Sort by dateTo ascending
                });
                this.setState({
                        students: sortedStudents,
                        filteredStudents: sortedStudents,
                        studentOrganizationalUnits: studentOrganizationalUnitsResponse.data,
                        faculties: facultiesResponse.data,
                        academicYears: academicYearsResponse.data.sort((a, b) => b.startYear - a.startYear),
                        countries: countriesResponse.data,
                        loading: false,
                        selectedAcademicYearId: academicYearsResponse.data.length > 0 ? academicYearsResponse.data[0].id : null,
                    }, () => {
                        this.filterStudents();
                    }
                );
            })
            .catch((error) => {
                toast(<FormattedMessage id="externalStudent.toast.errorFetchingData"/>);
                this.setState({ loading: false });
            });
    }

    getResults = (results) => {
        if (results.length === 0 && this.state.searchText.trim() === '') {
            this.filterStudents();
        } else {
            this.setState({
                filteredStudents: results,
                activePage: 1
            });
        }
    };

    handleSearchTextChange = (text) => {
        this.setState({ searchText: text });
    };

    filterStudents = () => {
        const {
            filteredStudents,
            excelData
        } = filterStudents(this.state);

        this.setState({
            filteredStudents,
            excelData,
            activePage: 1
        });
    };

    handlePaginationChange = (e, { activePage }) => {
        this.setState({ activePage });
    };

    handleCancelClick = () => {
        this.setState({ deletingRowId: null });
    };

    handleDeleteClick = (studentId) => {
        this.setState({ deletingRowId: studentId });
    };

    handleConfirmClick = () => {
        this.setState({ saving: true });
        axios.delete(`/external-student/${this.state.deletingRowId}`)
            .then((response) => {
                toast(<FormattedMessage id="externalStudent.toast.studentSuccessfullyDeleted"/>);
                this.setState((prevState) => ({
                    students: prevState.students.filter(student => student.id !== prevState.deletingRowId),
                    deletingRowId: null,
                    saving: false,
                }), () => {
                    this.filterStudents();
                });
            })
            .catch((error) => {
                this.setState({ saving: false });
                toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
            });
    };

    handleOpenNewTab = (code) => {
        const url = `${window.location.origin}/public/external-student-form/${code}`;
        window.open(url, '_blank');
    };

    render() {
        const {
            students,
            filteredStudents,
            excelData,
            loading,
            activePage,
            postsPerPage,
            deletingRowId,
            saving,
            registrationLink
        } = this.state;

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isInternationalCooperationService = localStorageRole === 'Služba za međunarodnu saradnju';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const isVicedean = localStorageRole.startsWith('Prodekan za međunarodnu');

        return (
            <div>
                <h2>{<FormattedMessage id="externalStudent.registeredStudents"/>}</h2>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3" style={{ margin: 0 }}>
                            {<FormattedMessage id="externalStudent.registeredStudentsUsingLink"/>}
                            <Header style={IconHeader} floated="right">
                                <Icon/>
                                <Popup
                                    trigger={<Icon link circular basic floated="right" name="arrow left"
                                                   onClick={() => window.history.go(-1)}/>}
                                    content={<FormattedMessage id="externalStudent.back"/>}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader
                                as={isVicedean ? undefined : 'a'}
                                onClick={isVicedean ? undefined : () => this.handleOpenNewTab(registrationLink.code)}
                                style={isVicedean ? undefined : { cursor: 'pointer' }}
                            >
                                {registrationLink ? registrationLink.code : '-'}
                            </Header.Subheader>

                        </Header>
                    </Segment>
                    <Segment>
                        {loading ? (
                            <Loader active inline="centered"/>
                        ) : students.length === 0 ? (
                            <Message>
                                Nema prijavljenih studenata za ovaj link.
                            </Message>
                        ) : (
                            <ExternalStudentsTable
                                students={students}
                                filteredStudents={filteredStudents}
                                excelData={excelData}
                                activePage={activePage}
                                postsPerPage={postsPerPage}
                                handlePaginationChange={this.handlePaginationChange}

                                getResults={this.getResults}
                                handleSearchTextChange={this.handleSearchTextChange}

                                deletingRowId={deletingRowId}
                                saving={saving}

                                handleDeleteClick={this.handleDeleteClick}
                                handleConfirmClick={this.handleConfirmClick}
                                handleCancelClick={this.handleCancelClick}

                                isAdmin={isAdmin}
                                isInternationalCooperationService={isInternationalCooperationService}
                                isStudentService={isStudentService}
                            />
                        )}
                    </Segment>
                    <ToastContainer position="top-right" hideProgressBar={true}/>
                </Segment.Group>
            </div>
        );
    }
}

export default RegistrationLinkStudentList;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentRegistrationLink/RegistrationLinkStudentList.js